import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Flame, Clock } from "lucide-react";

/**
 * Evergreen countdown — resets every 24h from first visit.
 * Creates urgency without being dishonest (offer rotates daily).
 */
const SellCountdownBanner = () => {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const KEY = "sell_countdown_start";
    let start = Number(localStorage.getItem(KEY));
    if (!start || Date.now() - start > 24 * 60 * 60 * 1000) {
      start = Date.now();
      localStorage.setItem(KEY, String(start));
    }
    const end = start + 24 * 60 * 60 * 1000;

    const tick = () => {
      const diff = Math.max(0, end - Date.now());
      setTimeLeft({
        hours: Math.floor(diff / 3600000),
        minutes: Math.floor((diff % 3600000) / 60000),
        seconds: Math.floor((diff % 60000) / 1000),
      });
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);

  const pad = (n: number) => String(n).padStart(2, "0");

  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      className="bg-gradient-to-r from-primary via-accent to-primary text-primary-foreground"
    >
      <div className="container mx-auto px-4 py-2.5 flex items-center justify-center gap-2 sm:gap-3 text-xs sm:text-sm font-medium flex-wrap">
        <Flame className="w-4 h-4 animate-pulse" />
        <span className="hidden sm:inline">Offre de lancement —</span>
        <span className="font-bold">-40% sur tous les plans</span>
        <div className="flex items-center gap-1 ml-2">
          <Clock className="w-3.5 h-3.5" />
          <span className="font-mono font-bold tabular-nums">
            {pad(timeLeft.hours)}:{pad(timeLeft.minutes)}:{pad(timeLeft.seconds)}
          </span>
        </div>
        <a 
          href="#pricing"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth", block: "start" });
          }}
          className="ml-2 underline underline-offset-2 hover:no-underline font-semibold"
        >
          En profiter →
        </a>
      </div>
    </motion.div>
  );
};

export default SellCountdownBanner;
